import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { environment } from 'src/environments/environment';
import { DoctorService } from '../common/doctor/doctor.service';
import { PersonService } from '../common/person/person.service';

@Injectable({
  providedIn: 'root',
})
export class AccountInformationService extends BaseService {
  constructor(
    protected store: Store<any>,
    protected rest: RestService,
    protected doctorService: DoctorService,
    protected personService: PersonService
  ) {
    super();
  }

  save = this.doctorService.save;

  loadDoctor = this.doctorService.getDoctorById;

  loadPerson = this.personService.getPersonById;

  getDoctorInformation = (username: string) =>
    this.rest.get({
      url: `${environment.endpoints.common}/doctor/byUsername/{username}`,
      urlParams: { username },
    });

  updatePass = (username?: string, password?: string) =>
    this.rest.patch<any>({
      url: `${environment.endpoints.admin}/user/pass/{username}`,
      body: password,
      urlParams: { username },
    });
}
